var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page checkout" },
    [
      _c("div", { staticClass: "onlyForHighScreens" }, [_vm._v(" ")]),
      _c("v-container", [
        _c(
          "h1",
          {
            staticClass: "text-center mt-3",
            staticStyle: { "margin-bottom": "2px" },
          },
          [_c("span", [_vm._v("Bestellung aufgeben")])]
        ),
      ]),
      _c("div", { staticClass: "text-center" }, [
        _c("h4", { staticClass: "mb-6" }, [
          _vm._v("Gesamtsumme: "),
          _c("span", { staticClass: "textFont" }, [
            _vm._v(_vm._s(_vm._f("priceTotal")(_vm.total))),
          ]),
        ]),
      ]),
      _c(
        "v-container",
        { staticClass: "ccontainer", attrs: { "grid-list-md": "" } },
        [
          _c(
            "div",
            { staticClass: "kioskCheckoutContainer" },
            [
              _c(
                "v-stepper",
                {
                  staticClass: "vvd orderform",
                  attrs: { vertical: "", id: "stepper" },
                  model: {
                    value: _vm.currentStep,
                    callback: function ($$v) {
                      _vm.currentStep = $$v
                    },
                    expression: "currentStep",
                  },
                },
                [
                  _c(
                    "v-stepper-step",
                    {
                      attrs: { complete: _vm.currentStep > 1, step: "1" },
                      nativeOn: {
                        "&click": function ($event) {
                          _vm.currentStep = 1
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "nice-title titleFont" }, [
                        _vm._v(
                          "Optional kannst du deinen Namen für die Abholung eingeben"
                        ),
                      ]),
                    ]
                  ),
                  _c("v-stepper-content", { attrs: { step: "1" } }, [
                    _vm.usecase.length > 0
                      ? _c("div", { attrs: { id: "checkData" } }, [
                          _c(
                            "div",
                            { staticClass: "bestelldaten pt-1" },
                            [
                              _c(
                                "v-form",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showForm,
                                      expression: "showForm",
                                    },
                                  ],
                                  ref: "inhouseMpDataForm",
                                  attrs: { "lazy-validation": "" },
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                  model: {
                                    value: _vm.valid,
                                    callback: function ($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "prelative" },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          outlined: "",
                                          value: _vm.name,
                                          label: "Dein Name",
                                          rules: _vm.nameRules,
                                          placeholder: "Dein Name",
                                          illed: "",
                                          "hide-details": "",
                                        },
                                        on: {
                                          input: _vm.updateName,
                                          focus: _vm.nameFocus,
                                          blur: _vm.unhideToolbar,
                                        },
                                      }),
                                      _vm.name
                                        ? _c(
                                            "div",
                                            { staticClass: "absClear" },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "myBlack",
                                                  on: {
                                                    "&click": function (
                                                      $event
                                                    ) {
                                                      $event.stopPropagation()
                                                      _vm.name = ""
                                                    },
                                                  },
                                                },
                                                [_vm._v("mdi-close ")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm.$store.state.enableOrderNote
                                    ? [
                                        _c("h4", { staticClass: "mt-4" }, [
                                          _vm._v("Hinweise zur Bestellung"),
                                        ]),
                                        _c("v-text-field", {
                                          staticClass: "nolabel",
                                          attrs: {
                                            outlined: "",
                                            "hide-details": "",
                                            clearable: "",
                                            illed: "",
                                          },
                                          on: { focus: _vm.hinweisFocus },
                                          model: {
                                            value: _vm.note,
                                            callback: function ($$v) {
                                              _vm.note = $$v
                                            },
                                            expression: "note",
                                          },
                                        }),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticClass: "mt-4 text-center" }, [
            _c(
              "div",
              [
                _c(
                  "v-btn",
                  {
                    staticClass:
                      "mt-3 orderBtn wallet-width text-none rounded100",
                    attrs: { color: "green", dark: "" },
                    nativeOn: {
                      "&click": function ($event) {
                        return _vm.finishStep1.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(" Bestätige deine Bestellung ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "text-center" },
        [
          _c("div", { staticClass: "spacer-25" }),
          _c(
            "v-btn",
            {
              staticClass: "text-none btn-mini",
              staticStyle: { "margin-top": "25px" },
              on: { click: _vm.cancelOrder },
            },
            [_vm._v(" Bestellung abbrechen ")]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "spacer-25" }),
      _c("ZvtDialog", {
        attrs: {
          total: _vm.total,
          terminalInstructions: _vm.terminalInstructions,
          dialog: _vm.showZvtDialog,
        },
        on: { close: _vm.closeZvtDialog },
      }),
      _vm.showKeyboard
        ? _c("div", { staticClass: "fixedVirtualKeyboard" }, [
            _c(
              "div",
              { staticClass: "superCenter" },
              [
                _c("VirtualKeyboard", {
                  attrs: { label: _vm.keyboardLabel },
                  on: {
                    enter: _vm.keyboardEnter,
                    close: function ($event) {
                      _vm.showKeyboard = false
                    },
                  },
                }),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }